/* DHC v1031 — Jack intent prefill + friction reduction */
(function(){
  'use strict';
  function bind(root){
    (root||document).querySelectorAll('[data-dhc-jack-prompt]').forEach(function(btn){
      if(btn.hasAttribute('data-dhc-size-help-v193'))return;
      if(btn.dataset.dhcV1031PromptReady==='1')return;
      btn.dataset.dhcV1031PromptReady='1';
      btn.addEventListener('click',function(){
        var prompt=(btn.getAttribute('data-dhc-jack-prompt')||'').trim();
        if(!prompt)return;
        window.setTimeout(function(){
          var w=document.querySelector('[data-dhc-support]');
          var form=w&&w.querySelector('[data-support-form]');
          var input=form&&form.elements&&form.elements.message;
          if(!input)return;
          input.value=prompt;
          input.dispatchEvent(new Event('input',{bubbles:true}));
          try{input.focus();input.setSelectionRange(input.value.length,input.value.length);}catch(e){}
        },120);
      });
    });
  }
  function boot(root){bind(root||document)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document)},{once:true});else boot(document);
  document.addEventListener('shopify:section:load',function(e){boot(e.target)});
})();
